import React from 'react';
export function LogoCloud() {
  return <section className="py-12 my-12" data-id="element-160">
      <div className="max-w-7xl mx-auto px-4 flex flex-col md:flex-row items-center justify-between gap-8 md:gap-12" data-id="element-161">
        <p className="text-body !text-gray-500 !text-[18px] italic whitespace-nowrap font-light" data-id="element-162">
          Respaldado por los mejores
        </p>
        <div className="w-full flex justify-end opacity-70 grayscale hover:grayscale-0 transition-all duration-500" data-id="element-163">
          <img src="https://cdn.magicpatterns.com/uploads/soeK3DLFyp9mZMA7tMd9x5/marcas.png" alt="Marcas que confían en nosotros" className="w-full max-w-4xl object-contain" data-id="element-164" />
        </div>
      </div>
    </section>;
}